import { create } from 'zustand'

type MuteState = {
  muted: boolean
  setMuted: (muted: boolean) => void
}

export const useMuteState = create<MuteState>()((set) => ({
  muted: true,
  setMuted: (muted: boolean) => set({ muted }),
}))
